module.exports = __webpack_public_path__ + "static/media/DSC_0057.1f2fd1e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0057.jpg
// module id = 589
// module chunks = 0